import { Flex, Text, Link } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

import { emptyValue } from '@/constants/common';

type AssetBasicInfoProps = {
  name: string;
  customId: string;
  serialNumber?: string;
  siteName?: string;
  onLinkClick: () => void;
};

export const AssetBasicInfo = ({
  name,
  customId,
  serialNumber,
  siteName,
  onLinkClick,
}: AssetBasicInfoProps) => {
  const { t } = useTranslation('common');

  return (
    <Flex vertical>
      <Link
        id={`asset-details-link-${name}-${customId}`}
        href=""
        onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
          e.preventDefault();
          e.stopPropagation();
          onLinkClick();
        }}>
        {name}
      </Link>
      <Text>
        {t('offboardings.deviceCard.serial', {
          serialNumber: serialNumber ? serialNumber : emptyValue,
        })}
      </Text>
      <Text>
        {t('offboardings.deviceCard.site', {
          siteName: siteName ? siteName : emptyValue,
        })}
      </Text>
    </Flex>
  );
};
